const gtmId = process.env['NX_GTM_SCRIPT_ID'];

export const getGTMHeadScript = () => {
  const gtmHeadScriptId = 'gtm-script-plg';
  const gtmScript = document.createElement('script');
  gtmScript.id = gtmHeadScriptId;
  gtmScript.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;
  return gtmScript;
};

export const getGTMBodyScript = () => {
  const gtmNoscriptId = 'gtm-noscript-plg';
  const gtmNoscript = document.createElement('noscript');
  gtmNoscript.id = gtmNoscriptId;
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.setAttribute('style', 'display:none;visibility:hidden');
  gtmNoscript.appendChild(iframe);
  return gtmNoscript;
};
